<div class="bg-m1 flex h-full cursor-default flex-col overflow-hidden">
  <div class="mx-6 mb-6 mt-8 flex min-h-0 flex-1 flex-col">
    <div class="flex h-11 flex-shrink-0 flex-row items-center">
      <div
        class="flex flex-row items-center"
        [ngClass]="{ 'w-1/4 justify-between': isSessionRoute }"
      >
        <div
          data-cy="explorerTitle"
          class="text-s1 flex select-none items-center self-center text-2xl font-semibold"
        >
          {{ pageTitle }}
        </div>

        <div *ngIf="!isNewSessionRoute" class="ml-10 flex-shrink-0">
          <button
            data-cy="explorerNewChatButton"
            type="button"
            class="border-s400 text-s500 hover:bg-s100 flex select-none flex-row items-center rounded border p-4 py-2 focus:outline-none"
            (click)="newChat()"
          >
            <div>New Chat</div>
          </button>
        </div>
      </div>

      <div class="flex flex-1"></div>

      <div class="ml-7 mr-5 flex flex-row items-center">
        <button
          data-cy="explorerHistoryButton"
          type="button"
          class="border-s400 hover:bg-s100 flex select-none flex-row items-center rounded border p-4 py-2 focus:outline-none"
          [ngClass]="{
            'text-m500 font-semibold': showHistory,
            'text-s500': !showHistory
          }"
          (click)="toggleHistory()"
          >History</button
        >
      </div>
    </div>

    <div class="mt-6 flex h-2 min-h-0 flex-1 flex-row">
      <ng-container *ngIf="!isSessionRoute">
        <div
          class="bg-m0 flex h-full w-full flex-grow overflow-hidden rounded shadow"
        >
          <router-outlet></router-outlet>
        </div>
      </ng-container>

      <ng-container *ngIf="isSessionRoute && showContent">
        <div
          class="bg-m0 flex h-full w-1/4 flex-shrink-0 flex-col rounded shadow"
        >
          <div class="flex flex-1 overflow-hidden">
            <router-outlet></router-outlet>
          </div>
        </div>

        <div
          class="bg-m0 ml-6 flex min-h-0 min-w-0 flex-1 flex-col rounded shadow"
        >
          <m-explorer-tabs
            class="flex-shrink-0"
            [tabs]="tabs"
            [activeTabId]="activeTabId"
            (tabSelect)="onTabSelect($event)"
            (tabClose)="onTabClose($event)"
          ></m-explorer-tabs>

          <ng-container *ngIf="activeTabContent as content; else noTab">
            @switch (content.status) {
              @case ('idle') {
                <div
                  class="flex flex-1 select-none items-center justify-center"
                >
                  <div
                    class="border-s200 border-t-m600 h-10 w-10 animate-spin rounded-full border-4"
                  >
                  </div>
                </div>
              }
              @case ('loading') {
                <div
                  class="flex flex-1 select-none items-center justify-center"
                >
                  <div
                    class="border-s200 border-t-m600 h-10 w-10 animate-spin rounded-full border-4"
                  >
                  </div>
                </div>
              }
              @case ('error') {
                <div
                  class="text-s500 flex flex-1 flex-col gap-2 overflow-auto p-6"
                >
                  <div class="text-r1 mb-2 text-xl font-semibold">Errors</div>
                  @for (e of content.errors; track e) {
                    <div
                      class="bg-r100 text-r700 mb-2 w-fit max-w-full rounded px-4 py-3"
                    >
                      <div class="text-r1 font-semibold">{{ e.title }}</div>
                      <div class="mt-1 whitespace-pre-wrap break-words">{{
                        e.message
                      }}</div>
                    </div>
                  }
                </div>
              }
              @case ('ready') {
                <div class="flex min-h-0 flex-1 flex-col p-6">
                  <m-explorer-chart
                    class="flex h-full min-h-0 flex-1"
                    [tile]="syntheticTile(content)"
                    [mconfig]="content.mconfig"
                    [query]="content.query"
                    [chartId]="content.chart.chartId"
                    [title]="content.chart.title"
                  ></m-explorer-chart>
                </div>
              }
            }
          </ng-container>

          <ng-template #noTab>
            <div
              class="text-s500 flex flex-1 select-none items-center justify-center text-xl"
            >
              No tab selected
            </div>
          </ng-template>
        </div>
      </ng-container>

      <ng-container *ngIf="isSessionRoute && !showContent">
        <div class="bg-m0 h-full w-1/4 flex-shrink-0 rounded shadow"></div>

        <div class="bg-m0 ml-6 min-h-0 min-w-0 flex-1 rounded shadow"></div>
      </ng-container>
    </div>
  </div>
</div>

<m-explorer-history
  *ngIf="showHistory"
  (close)="showHistory = false"
></m-explorer-history>

<div *ngIf="nav$ | async"></div>
<div *ngIf="routerEvents$ | async"></div>
<div *ngIf="tabs$ | async"></div>
<div *ngIf="activeTabId$ | async"></div>
<div *ngIf="activeTabContent$ | async"></div>
<div *ngIf="showContent$ | async"></div>
